/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function Gltf(props) {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_15371_23767)">
        <path
          d="M10.5415 16.7945C10.9904 16.29 11.2276 15.5526 11.2276 14.5595V9.01166H10.2796V9.87981H10.2679C10.0884 9.54359 9.83882 9.29149 9.51888 9.12323C9.19894 8.95512 8.84767 8.87098 8.46538 8.87098C7.94259 8.87098 7.50161 8.97069 7.14274 9.17014C6.78387 9.36959 6.49495 9.62586 6.27659 9.93861C6.05801 10.2514 5.9019 10.5955 5.80823 10.9711C5.71459 11.3466 5.66779 11.7142 5.66779 12.0739C5.66779 12.4885 5.7243 12.8817 5.83752 13.253C5.95053 13.6246 6.12024 13.9511 6.34663 14.2327C6.57287 14.5143 6.85391 14.7372 7.18936 14.9015C7.52481 15.0658 7.91896 15.1479 8.37181 15.1479C8.55909 15.1479 8.74831 15.1244 8.9393 15.0775C9.13063 15.0306 9.31003 14.9622 9.47791 14.8722C9.64561 14.7824 9.79572 14.6689 9.92863 14.532C10.0612 14.3952 10.1704 14.2329 10.2565 14.0452H10.2795V14.4439C10.2795 14.788 10.2462 15.1008 10.18 15.3825C10.1136 15.664 10.0063 15.9046 9.85822 16.104C9.7099 16.3034 9.52247 16.4597 9.2965 16.5734C9.07008 16.6867 8.79317 16.7435 8.46563 16.7435C8.30173 16.7435 8.12987 16.7259 7.95044 16.6908C7.88566 16.6781 7.8227 16.6625 7.76154 16.6441C7.695 16.6206 7.62901 16.5967 7.56356 16.5723C7.55748 16.5697 7.55142 16.5671 7.54537 16.5644V16.5655C4.97459 15.6032 3.28152 13.9668 3.28152 12.1089C3.28152 9.14752 7.58491 6.74701 12.895 6.74701C15.8526 6.74701 18.5061 7.4222 20.267 8.59396C18.3422 6.63056 14.89 5.25 10.9455 5.25C4.90252 5.24893 0.00304131 8.31961 4.37574e-08 12.1056C-0.000364908 14.6911 2.28216 16.9432 5.65371 18.1137C8.358 18.2065 9.729 17.7034 10.538 16.7947L10.5415 16.7945ZM10.1334 12.7647C10.067 13.0462 9.96366 13.2984 9.82316 13.5213C9.68274 13.7442 9.49713 13.9243 9.26721 14.0608C9.03696 14.1978 8.75811 14.2661 8.43026 14.2661C8.10241 14.2661 7.8293 14.1978 7.61094 14.0608C7.3924 13.9241 7.21679 13.7441 7.08419 13.5213C6.95141 13.2984 6.8578 13.0503 6.80327 12.7763C6.74862 12.5026 6.72134 12.2288 6.72134 11.9551C6.72134 11.6658 6.75443 11.3881 6.82082 11.122C6.88706 10.8562 6.99238 10.6215 7.13681 10.4181C7.28112 10.2148 7.46648 10.0526 7.69275 9.93133C7.91899 9.81016 8.19213 9.7495 8.51207 9.7495C8.8241 9.7495 9.0893 9.8122 9.30797 9.93721C9.52633 10.0624 9.70394 10.2287 9.84049 10.4359C9.97692 10.6432 10.0764 10.8758 10.139 11.134C10.2013 11.3921 10.2326 11.6543 10.2326 11.9201C10.2326 12.2017 10.1993 12.4834 10.1331 12.7648L10.1334 12.7647Z"
          fill="#86C540"
        />
        <path
          d="M11.0004 17.3693C10.4271 17.8909 9.40284 18.4865 8.00781 18.7203C8.94178 18.883 9.92563 18.9701 10.9423 18.9702C14.8716 18.971 18.3143 17.5957 20.2455 15.6445C18.4822 16.8093 15.8418 17.472 12.8948 17.472C12.1947 17.472 11.6592 17.4473 11.0016 17.368L11.0004 17.3693Z"
          fill="#86C540"
        />
        <path
          d="M17.0521 15.0917H15.6239V10.2693H13.832V9.04297H18.844V10.2693H17.0521V15.0917Z"
          fill="#86C540"
        />
        <path
          d="M21.0183 15.0946H19.5898V9.04688H23.9997V10.2732H21.0186V11.405H23.628V12.6313H21.0186L21.0183 15.0946Z"
          fill="#86C540"
        />
        <path
          d="M12.0586 7.53516H13.0534V15.0735H12.0586V7.53516Z"
          fill="#86C540"
        />
      </g>
      <defs>
        <clipPath id="clip0_15371_23767">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

Gltf.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Gltf
